import { FC } from 'react';
import cn from 'classnames';

import { DataLink } from 'components/Shared/SharedComponents';

import styles from './PsychicCharacteristic.module.scss';

import type { IPsychicCharacteristic, IPsychicCharacteristicMock } from '../config/declarations';
import { shortenLine } from '../lib';

/* Nested Component */
const Mock: FC<IPsychicCharacteristicMock> = ({ className }) => (
  <div className={cn(styles.mock, className)} />
);

/* Main Component */
const PsychicCharacteristic: FC<IPsychicCharacteristic> = ({
  text,
  className,
  linkProps,
  textLengthLimit = 95,
  moreLabel = '>>>',
}) => {
  const trimmedText = text?.trim();

  if (!trimmedText || trimmedText === '.') {
    return <Mock className={className} />;
  }

  const displayText = shortenLine(trimmedText, textLengthLimit);

  return (
    <div className={cn(styles.characteristic, className)}>
      <i
        aria-hidden
        className={styles.tail}
      />

      <p className={styles.text}>
        &ldquo;
        {displayText}
        &rdquo;
      </p>

      <DataLink
        className={styles.more}
        href={linkProps?.profileUrl}
        gaData={linkProps?.gaData}
        link={linkProps?.profileLink!}
      >
        {moreLabel}
      </DataLink>
    </div>
  );
};

export default PsychicCharacteristic;
